import MsgParser from '../net/MsgParser';
import Component from './Component';
import log from 'loglevel';

/**
 *
 *
 * @export
 * @class MessageController
 * @extends {Component}
 * @author zhenliang.sun
 */
export default class MessageController extends Component {
  constructor(store = null) {
    super();
    this.store = store;
    this._ee = this.store.getKV('ee');
    this._isRegistered = false;
  }

  /**
   * 符合接口的一个实例
   *
   * @param {*} iM
   * @memberof MessageController
   */
  registMsg(iM) {
    this.poster = iM;
    this.poster.store = this.store;
    this.parser = new MsgParser(this.store);
    this._isRegistered = true;
  }

  /**
   * 卸载收发消息实例，卸载后若不再次注册，将无法进行消息收发
   *
   * @memberof MessageController
   */
  unregistMsg() {
    this.destroy();
  }

  sendMessage(msg) {
    if (!this.isRegistered) {
      log.warn('Have not been registered Poster or Parser, can not send message');
      return;
    }
    const o = this.parser.parse(msg);
    let able = this.store.getKV('pageable') || this.store.getKV('editable') || false;
    console.log('sendMessage前 权限验证结果', able);
    if (able) {
      console.log('messageConreoller触发poster send', o);
      this.poster.send(o);
    } else {
      log.debug(`No sendMessage. pageable: ${this.store.getKV('pageable')}, editable: ${this.store.getKV('editable')}`);
    }
  }

  sendMessageEvent(act, data) {
    this.poster.sendEventToMobile(act, data);
  }

  receiveMessage(msg) {
    if (!this.poster) {
      log.warn('Have not been registered Poster or Parser, can not receive message');
      return;
    }

    const m = this.parser.analyze(msg);
    // log.info(m);
    this._ee.dispatch('remote_message', m);
  }

  destroy() {
    super.destroy();
    this.poster = null;
    this.parser = null;
    this._isRegistered = false;
  }

  /**
   * @description 是否注册了消息收发器
   * @readonly
   * @memberof MessageController
   */
  get isRegistered() {
    return this._isRegistered;
  }
}
